import React, { Suspense, FC } from 'react'
import { renderRoutes, RouteConfigComponentProps } from 'react-router-config'
import { makeStyles } from '@material-ui/core/styles'
import { LinearProgress } from '@material-ui/core'

const useStyles = makeStyles(() => ({
    content: {
        height: '100%',
    },
}))

const Auth: FC<RouteConfigComponentProps<any>> = ({ route }) => {
    const classes = useStyles()

    return (
        <>
            <main className={classes.content}>
                <Suspense fallback={<LinearProgress />}>{renderRoutes(route.routes)}</Suspense>
            </main>
        </>
    )
}

export default Auth
